import schemas from 'components/forms/fields/definedSchemas';
import Joi from 'joi';

const fields = {
    document_signed: {
        ...schemas.boolRequiredTrue,
        label: 'Is this COD form signed by the Master of the vessel?',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be signed.',
        }),
    },
    date_document_signed: {
        ...schemas.dateRequiredMaxToday,
        label: 'What date was the document signed by the Master of the vessel?',
        section: 'Signature',
        validation: Joi.when(Joi.ref('document_signed'), {
            is: true,
            then: schemas.dateRequiredMaxToday.validation,
            otherwise: Joi.string().allow(''),
        }),
    },
    document_signed_user: {
        ...schemas.boolRequiredTrue,
        label: 'Is this COD form signed by you?',
        section: 'Signature',
        validation: schemas.boolRequiredTrue.validation.messages({
            'any.invalid': 'Form must be signed.',
        }),
    },
    date_shipment: {
        ...schemas.dateRequiredMaxToday,
        label: 'Date of Shipment',
        section: 'Shipment Discharge',
        validation: schemas.dateRequiredMaxToday.validation
            .max(Joi.ref('date_detached'))
            .messages({
                'date.min':
                    'The date of shipment you entered is invalid. Please enter only service from within the last century.',
                'date.max': "Start date can't be after end date",
            }),
    },
    place_shipment: {
        ...schemas.textRequired,
        label: 'Place of Shipment',
        section: 'Shipment Discharge',
    },
    date_detached: {
        ...schemas.dateRequiredMaxToday,
        label: 'Date of Discharge',
        section: 'Shipment Discharge',
    },
    place_discharge: {
        ...schemas.textRequired,
        label: 'Place of Discharge',
        section: 'Shipment Discharge',
    },
    vessel_id: {
        ...schemas.integerRequired,
        label: 'Vessel',
        hidden: true,
    },
    department: {
        component: 'Department',
        label: 'Did you serve in the Deck Department or the Engine Department?',
        name: 'department',
        section: 'Position Served',
    },
    deck_position_served: {
        component: 'Department',
        label: 'Deck Positions',
        name: 'deck_position_served',
        section: 'Position Served',
    },
    engine_position_served: {
        component: 'Department',
        label: 'Engine Positions',
        name: 'engine_position_served',
        section: 'Position Served',
    },

    offshore_installation_department: {
        component: 'Rating',
        label: 'What department did you serve on this vessel?',
        name: 'offshore_installation_department',
        section: 'Rating',
    },
    offshore_installation_deck_position_served: {
        component: 'Rating',
        label: 'What position did you serve in the Marine Department on this vessel?',
        name: 'offshore_installation_deck_position_served',
        section: 'Rating',
    },
    offshore_installation_engine_position_served: {
        component: 'Rating',
        label: 'What position did you serve in the Maintenance Department on this vessel?',
        name: 'offshore_installation_engine_position_served',
        section: 'Rating',
    },
    offshore_installation_drilling_position_served: {
        component: 'Rating',
        label: 'What position did you serve in the Drilling Department on this vessel?',
        name: 'offshore_installation_drilling_position_served',
        section: 'Rating',
    },
    offshore_installation_supportstaff_position_served: {
        component: 'Rating',
        label: 'What position did you serve on this vessel?',
        name: 'offshore_installation_supportstaff_position_served',
        section: 'Rating',
    },
    nature_of_voyage: {
        ...schemas.radioRequired,
        label: 'Nature of Voyage',
        section: 'Nature of Voyage',
        options: {
            Oceans: 'Oceans',
            'Near Coastal': 'Near Coastal',
            Inland: 'Inland',
            'Great Lakes': 'Great Lakes',
            'Western Rivers': 'Western Rivers',
        },
    },
};

export default fields;
